import { format } from 'date-fns';
import { utcToZonedTime } from "date-fns-tz";
import { getProductTypeById, OPTIONS_TIMEZONE, REPORTING_TIMEZONE, TRUE_AND_FALSE } from 'helpers/sf_constants';
import { timeFormatter } from 'helpers/sf_dashboard_helper';
import { dollarFormatWithTwoDecimalPlaces, formatToUsdWithTwoDecimalPlaces, getCallStatusHTML, getIANATimezoneStringForAbbreviation, getOptionFromValueForSelectBox, percentFormatWithTwoDecimalPlaces, Sfdelimitter, sortByDateDESC } from 'helpers/sf_utils';
import { BROWSER_IANA_TIMEZONE, convertDateBetweenTimezones } from 'helpers/time_utils';
import { UncontrolledTooltip } from 'reactstrap';


export const FORMATTER_SIGN = {
    PERCENT_SIGN: 'percent_sign',
    DOLLAR_SIGN: 'dollar_sign',
    DELIMITTER: 'delimitter',
    TIME: 'time'
}

export function defaultFormatter(cellContent, row) {
    return (
        <span>{cellContent ? cellContent : "--"}</span>
    )
}

export function defaultNumberFormatter(cellContent, row) {
    return (
        <span>{cellContent != null ? cellContent : 0}</span>
    )
}

// For Name Formatter
export function nameFormatter(cellContent, row) {
    return (
        <span>{row.first_name + " " + row.last_name}</span>
    )
}


// For true/false check Formatter
export function trueToYesFormatter(cellContent, row) {
    return (
        <span>{cellContent === true ? "Yes" : "No"}</span>
    )
}


// For Status Formatter
export function statusFormatter(cellContent, row) {
    return (
        <span>{cellContent === true ? "Active" : "Paused"}</span>
    )
}

// For invoice Formatter
export function invoiceFormatter(cellContent, row) {
    return (
        <span>{(cellContent != null) ? (cellContent == 0) ? ("No") : ("Yes") : "--"}</span>
    )
}

// For rebill Formatter
export function rebillFormatter(cellContent, row) {

    return (
        <span>{row?.accounts?.[0].billing_setting?.invoice === 1 ? "--" : ((cellContent != null) ? (cellContent == 0) ? ("No") : ("Yes") : "--")}</span>
    )
}

export function cityFormatter(cellContent, row) {
    return (
        <span className='text-capitalize'>{cellContent ? cellContent : "--"}</span>
    )
}

// For Location Formatter
export function locationFormatter(cellContent, row) {
    return (
        <span className='text-capitalize'>{(row?.city || "--") + ", " + (row?.state || "--")}</span>
    )
}

// For Date Created Formatter
export function dateCreatedFormatter(cellContent, row) {
    return (
        <span>{cellContent ? format(utcToZonedTime(cellContent, getIANATimezoneStringForAbbreviation(REPORTING_TIMEZONE)), 'MM/dd/yyyy hh:mm aa') : "--"}</span>
    )
}

// For activation Time Formatter
export function activationTimeFormatter(cellContent, row) {
    return (
        <span>{cellContent ? format(convertDateBetweenTimezones(Date.parse(cellContent), REPORTING_TIMEZONE, BROWSER_IANA_TIMEZONE), 'MM/d/yyyy hh:mm aa') : "--"}</span>
    )
}

// For timezone Formatter
export function timezoneFormatter(cellContent, row) {
    return (<span>{cellContent ? getOptionFromValueForSelectBox(OPTIONS_TIMEZONE, cellContent)?.label : "--"}</span>)
}

// For Total BalanceFormatter Formatter
export function totalBalanceFormatter(cellContent, row) {
    return (
        <span>{dollarFormatWithTwoDecimalPlaces(parseFloat(row?.accounts[0]?.account_balance?.current_balance || '0.0') + parseFloat(row?.accounts[0]?.account_balance?.promo_balance || '0.0'))}</span>
    )
}

export function distinctProductTypesFormatter(cellContent, row) {
    return (
        <span className='text-capitalize'>
            {
                cellContent ? (
                    cellContent.split(',').map(el => getProductTypeById(parseInt(el))?.name).join(', ')
                ) : "--"
            }
        </span>
    )
}
// For Phone Number Formatter
export function phoneNumberFormatter(cellContent, row) {
    return (
        <span>{cellContent ? cellContent.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : "--"}</span>
    )
}

// For Phone Number Formatter
export function phoneNumberWithCodeFormatter(cellContent, row) {
    return (
        <span>{cellContent ? cellContent.replace(/(\+\d{1,2})(\d{3})(\d{3})(\d{4})/, '$1-$2-$3-$4') : "--"}</span>
    )
}

export function phoneNumberFormmaterString(number) {
    if (!number) return '--';
    return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}

// For Truncate Formatter
export function truncateURLFormatter(cellContent, row, colIndex) {
    return (
        <div className="text-truncate">
            <span id={`tooltip-truncate-formatter-${row?.id}-${colIndex}`}>{cellContent ? cellContent : "--"}</span>
            <UncontrolledTooltip placement="left" target={`tooltip-truncate-formatter-${row?.id}-${colIndex}`}>
                {cellContent}
            </UncontrolledTooltip>
        </div>
    )
}

// For Truncate Formatter
export function onHoverPopUpTooltipFormatter(cellContent, row, colIndex, keyField) {
    return (
        <div className="text-truncate">
            <span id={`hover-tooltip-${keyField || ""}-${row?.id}-${colIndex}-formatter`}>{cellContent ? cellContent : "--"}</span>
            {
                cellContent && (
                    <UncontrolledTooltip placement="left" target={`hover-tooltip-${keyField || ""}-${row?.id}-${colIndex}-formatter`}>
                        {cellContent}
                    </UncontrolledTooltip>
                )
            }
        </div>
    )
}

// For Yes No Formatter
export function yesNoFormatter(cellContent, row) {
    return (
        <span>{cellContent ? "Yes" : "No"}</span>
    )
}

export const commaFormatter = (cell) => (
    <div className="p-1">
        <span>{cell == null ? (cell = 0) : cell.toLocaleString()}</span>
    </div>
)

//Yes No formatter with null values
export function yesNoWithNullValuesFormatter(cellContent, row) {
    return (
        cellContent === TRUE_AND_FALSE.FALSE ? 'No' :
            cellContent === TRUE_AND_FALSE.TRUE ? 'Yes' :
                '--'
    );
}

export const customFooterFormatter = (column, sign) => {
    const footer_field_name = column?.isDataFieldName ? column?.dataField : column?.columnName
    switch (sign) {
        case FORMATTER_SIGN.DOLLAR_SIGN:
            return (
                <div className="footer-container">
                    <div className="footer-text">
                        {formatToUsdWithTwoDecimalPlaces(column?.footerData?.[footer_field_name] || "0.00")}
                    </div>
                </div>
            )

        case FORMATTER_SIGN.PERCENT_SIGN:
            return (
                <div className="footer-container">
                    <div className="footer-text">
                        {percentFormatWithTwoDecimalPlaces(column?.footerData?.[footer_field_name] || "0.00")}
                    </div>
                </div>
            )
        case FORMATTER_SIGN.TIME:
            return (
                <div className="footer-container">
                    <div className="footer-text">
                        {timeFormatter(column?.footerData?.[footer_field_name])}
                    </div>
                </div>
            )

        default:
            return (
                <div className="footer-container">
                    <div className="footer-text">
                        {Sfdelimitter(column?.footerData?.[footer_field_name] || "0.00")}
                    </div>
                </div>
            )
    }
}

export const callStatusFormatter = (_, row) => {
    if (!row?.quote_calls?.length) {
        return (
            <div className="call-status-table-formatter">
                <span className="fs-13">--</span>
            </div>
        );
    }

    if (row?.quote_calls?.length > 1) {
        return (
            <>
                <UncontrolledTooltip placement="top" target={`call-status-${row.id}`}>
                    {sortByDateDESC(row?.quote_calls, 'created_at').map((qc, index) => (
                        <p className='mt-2' key={index}>{getCallStatusHTML(qc.status)} | {timeFormatter(qc.call_duration || '0.0')}</p>
                    ))}
                </UncontrolledTooltip>
                <div id={`call-status-${row.id}`}>
                    <span className="fs-13">
                        <i className="mdi mdi-phone-log text-primary"></i> Multiple Calls
                    </span>
                </div>
            </>
        );
    }

    const STATUS_HTML = getCallStatusHTML(row?.quote_calls[0]?.status);

    return (
        <div className="call-status-table-formatter">
            <span className="fs-12">{STATUS_HTML}</span>
        </div>
    );
}

export const callDurationFormatter = (_, row) => {
    if (!row?.quote_calls?.length) {
        return "--"
    }
    const latestCall = (row?.quote_calls || []).reduce((prev, current) => (new Date(prev.created_at) > new Date(current.created_at)) ? prev : current);
    return timeFormatter(latestCall.call_duration || '0.0');
}